import styled from 'styled-components';

const RatingAverageContainer = styled.div`
  font-weight: normal;
  min-width: 320px;
`;

const RatingAverageStyle = styled.span`
  font-weight: bold;
  font-size: 64px;
  line-height: 72px;
`;

export default RatingAverageContainer;
export { RatingAverageContainer, RatingAverageStyle };
